import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function LoadingSpinner({ size = 'md', className }: LoadingSpinnerProps) {
  const { t } = useTranslation('common')

  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
  }

  return (
    <div
      className={cn(
        'animate-spin rounded-full border-gray-300 border-t-gray-900',
        sizeClasses[size],
        className
      )}
      role="status"
      aria-label={t('aria.loading')}
    >
      <span className="sr-only">{t('aria.loading')}</span>
    </div>
  )
}
